<template>
  <div style="padding: 20px;">
    <el-row>
      <el-form>
        <el-form-item label-position="left" label-width="150px" label="选择属性后赋值：">
          <el-select style="width:200px;" v-model="mattrinfo" :hidden="attrpanel" filterable placeholder="请选择需要添加的属性" height="120px" @change="attrchange">
            <el-option
              v-for="(item,index) in mattrs"
              :key="index"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <el-button style="margin-left: 10px;" type="success" icon="el-icon-plus" @click="baseattrmana">新增属性</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-form>
        <el-form-item v-for="(attr,index) in attrlist" :key="index">
          <el-input :placeholder="'请输入:' + attr.value" v-model="attr.value">
            <template slot="prepend">{{attr.name}}</template>
            <el-button slot="append" @click="delattr(index)" icon="el-icon-close"></el-button>
          </el-input>
        </el-form-item>
        <el-button v-if="attrlist.length > 0" type="primary" icon="el-icon-edit-outline" @click="saveattrs" round>保存属性</el-button>
      </el-form>
    </el-row>
    <el-divider></el-divider>
    <div style="margin-bottom: 20px;">已分配属性：</div>
    <el-table
      :data="attrtbdataex"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}"
      fit>
      <el-table-column
        prop="attrname"
        label="属性名称"
      >
      </el-table-column>
      <el-table-column
        prop="attrvalue"
        label="属性值"
      >
      </el-table-column>
      <el-table-column
        label="操作"
        min-width="50px"
      >
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="删除产品属性" placement="top-start">
            <i class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="delgoodsattr(scope.$index, attrtbdataex)"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="基础属性" :visible.sync="baseattrvisible" @close="closegbpanel">
      <GAttrs @getattrs="getattrs"></GAttrs>
    </el-dialog>
    <el-dialog title="当前商品已添加属性" :visible.sync="attrpanelvisible">
      <el-table
        :data="attrtbdataex"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        fit>
        <el-table-column
          prop="attrname"
          label="属性名称"
        >
        </el-table-column>
        <el-table-column
          prop="attrvalue"
          label="属性值"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          min-width="50px"
        >
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="删除产品属性" placement="top-start">
              <i class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="delgoodsattr(scope.$index, attrtbdataex)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
  import Vue from 'vue'
  import axios from 'axios'
  import GAttrs from './GAttrs'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'MAttrs',
    components: {
      GAttrs
    },
    props: {
      curgoodsid: {
        type: Number,
        required: true
      }
    },
    data () {
      return {
        attrpanel: false,
        mattrinfo: '',
        mattrs: [],
        attrtbdataex: [],
        attrpanelvisible: false,
        baseattrvisible: false,
        attrlist: [],
        khid: ''
      }
    },
    created: function () {
      that = this
      if (getCookie('cusid') !== 0 || getCookie('cusid') !== '' || getCookie('cusid') !== undefined) {
        this.khid = getCookie('cusid')
      } else {
        this.khid = 1
      }
      if (that.khid === null) {
        that.$message({
          type: 'info',
          message: 'Cookie已失效，请重新登录!'
        })
        that.$router.push({path: '/'})
      } else {
        that.$options.methods.getattrs()
        that.getdbattrs()
      }
    },
    methods: {
      closegbpanel () {
        that.getattrs()
      },
      baseattrmana () {
        that.baseattrvisible = true
      },
      getdbattrs () {
        var qstr = {
          whereinfo: 'goods_id = ' + localStorage.getItem('curgoodsid') + ' and attrtype = 0',
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/querbgav',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              that.attrtbdataex = res.data
              localStorage.setItem('newgattrs',JSON.stringify(that.attrtbdataex))
            } else {
              localStorage.setItem('newgattrs','[]')
              that.attrtbdataex = []
            }
            that.$emit('reloaddata');
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      getattrs () {
       var qstr = {
         whereinfo: 'ownphone = ' + localStorage.getItem('username') + ' and type=0',
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/querbga',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              console.log(res)
              that.mattrs = res.data
            } else {
              that.mattrs = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      attrchange (val) {
        var dataindex = this.mattrs.findIndex(d => d.id === val)
        console.log(val)
        var adtmp = {
          id: this.mattrs[dataindex].id,
          name: this.mattrs[dataindex].name,
          value: ''
        }
        this.attrlist.push(adtmp)
      },
      saveattrs () {
        // 在保存属性前先清空原有的属性，清空后再添加
        var adatas = []
        for (var index in that.attrlist) {
          var subdata = that.attrlist[index]
          var adata = {
            goods_id: localStorage.getItem('curgoodsid').toString(),
            attrid: subdata.id.toString(),
            attrtype: '0',
            attrname: subdata.name.toString(),
            attrvalue: subdata.value,
            cusid: that.khid.toString(),
            ownphone: localStorage.getItem('username')
          }
          adatas.push(adata)
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/paddbgav',
          method: 'post',
          data: adatas,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.result === 'success') {
              that.attrlist = []
              that.getdbattrs()
              that.$message({
                type: 'success',
                message: '保存属性成功!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
        /*
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/goods/dgav',
          method: 'post',
          data: {
            whereinfo: {'String': 'goods_id=' + parseInt(localStorage.getItem('curgoodsid')), Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success) {
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          }) */
      },
      delattr (index) {
        this.attrlist.splice(index, 1)
      },
      seeattrs () {
        this.attrpanelvisible = true
        that.$options.methods.getdbattrs()
      },
      delgoodsattr (index, data) {
        var curselectdata = data[index]
        console.log(curselectdata)
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/delbgav',
          method: 'post',
          data: {
            id: curselectdata.id.toString()
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.result === 'success') {
              that.getdbattrs()
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      nextspec () {
        that.$emit('nextspec');
      },
      prebaseinfo () {
        that.$emit('prebaseinfo');
      }
    }
  }
  function getCookie (name) {
    var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
    return v ? v[2] : null
  }
</script>

<style scoped>
  .el-select .el-input {
    width: 130px;
  }
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/newgoods/MAttrs.vue